import { MessageTypes } from 'store/declarations/enums/common/declaration-types';
import { additionalDocumentSchema } from 'views/declarations/ireland/ens/validation/irelandEnsValidation';
import { producedDocumentsWritingOffSchema } from 'views/declarations/ireland/import/h1/validation/ValidationSchema';
import { supportingDocumentSchema } from 'views/declarations/ireland/import/h7/validation/ValidationSchema';

const validationSchemasMap: Record<'master' | 'product', Partial<Record<string, any>>> = {
    master: {
        ...Object.fromEntries(
            ['H1', 'H2', 'H3', 'H4', 'H5', 'H6'].map((key) => [key, producedDocumentsWritingOffSchema])
        ),
        H7: supportingDocumentSchema,
    },

    product: {
        ...Object.fromEntries(
            ['H1', 'H2', 'H3', 'H4', 'H5', 'H6'].map((key) => [key, producedDocumentsWritingOffSchema])
        ),
        H7: supportingDocumentSchema,
        ENS: additionalDocumentSchema,
    },
};

export const getBox44ValidationSchema = ({
    messageType,
    isProduct,
}: {
    messageType?: MessageTypes;
    isProduct?: boolean;
}) => {
    if (!messageType || isProduct === undefined) return undefined;

    const level = isProduct ? 'product' : 'master';

    return validationSchemasMap[level]?.[messageType];
};
